// Ordered module -> path list plus the "first reachable page" resolver used by
// the /card-issuing landing to bounce a user to a page they can actually
// access.
//
// This is a LEAF module: it imports only contstants, never page components or
// appModulesConfig. That is deliberate — appModulesConfig imports the page
// components (including the card-issuing landing), so if the landing imported
// appModulesConfig back we would form an import cycle and `appRoutes` would be
// read in its temporal dead zone (ReferenceError at runtime).
//
// The order and paths mirror the sidebar in appModulesConfig; keep them in sync
// when routes are added or moved.
import {
  MOD_CARD_ISSUING,
  MOD_CARD_HOLDERS,
  MOD_PROGRAMS,
  MOD_ORDER,
  MOD_SEARCH_ORDER,
  MOD_SELL_ORDER,
  MOD_VOID_CARDS,
  MOD_BATCH_SELL_ORDER,
  MOD_CARD_BALANCE,
  MOD_REPLACE_CARDS,
  MOD_COMBINE_CARDS,
  MOD_SHIFT_REPORT,
  MOD_KIOSK_REPORT,
  MOD_OFFICE,
  MOD_SHIPPING_ADDRESS,
  MOD_REPORT,
  MOD_USERS,
  MOD_CORPORATE_CUSTOMERS,
  MOD_REPORTS,
  MOD_AUDIT_LOGS,
} from "../contstants";

export const NAV_ROUTES = [
  { module: MOD_CARD_ISSUING, path: "/card-issuing" },
  { module: MOD_CARD_HOLDERS, path: "/card-issuing/cardholders" },
  { module: MOD_PROGRAMS, path: "/card-issuing/programs" },
  { module: MOD_ORDER, path: "/card-issuing/orders" },
  { module: MOD_SEARCH_ORDER, path: "/card-issuing/searchorder" },
  { module: MOD_SELL_ORDER, path: "/card-issuing/sell-orders" },
  { module: MOD_VOID_CARDS, path: "/card-issuing/void-cards" },
  { module: MOD_BATCH_SELL_ORDER, path: "/card-issuing/batch-order" },
  { module: MOD_CARD_BALANCE, path: "/card-issuing/check-card-balance" },
  { module: MOD_REPLACE_CARDS, path: "/card-issuing/replace-cards" },
  { module: MOD_COMBINE_CARDS, path: "/card-issuing/combine-cards" },
  { module: MOD_SHIFT_REPORT, path: "/card-issuing/shift-report" },
  { module: MOD_KIOSK_REPORT, path: "/card-issuing/kiosk-report" },
  { module: MOD_OFFICE, path: "/offices" },
  { module: MOD_SHIPPING_ADDRESS, path: "/offices/shipping-addresses" },
  { module: MOD_REPORT, path: "/reports" },
  { module: MOD_USERS, path: "/settings/users" },
  { module: MOD_CORPORATE_CUSTOMERS, path: "/settings/corporate-customers" },
  { module: MOD_REPORTS, path: "/settings/program-reports" },
  { module: MOD_AUDIT_LOGS, path: "/settings/logs" },
];

// Returns the first route path the user can actually reach, honoring company
// config (allowedModules), the static role matrix (can), and the dynamic module
// gate (canAccessModule) — the same triple the sidebar uses. Skips the
// /card-issuing landing itself so it never redirects to the bouncer, and falls
// back to it when nothing else is reachable.
export const firstAccessiblePath = ({
  allowedModules = [],
  can,
  canAccessModule,
} = {}) => {
  const match = NAV_ROUTES.find(
    (route) =>
      route.path !== "/card-issuing" &&
      allowedModules.includes(route.module) &&
      (!can || can(route.module, "read")) &&
      (!canAccessModule || canAccessModule(route.module))
  );
  return match?.path || "/card-issuing";
};
